import { useState, useMemo } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import ProductCard from "./ProductCard";
import { useProducts } from "../lib/ProductsContext";

const TABS = [
  { id: "all", label: "Tümü" },
  { id: "cok-satan", label: "Çok Satanlar" },
  { id: "yeni", label: "Yeni Koleksiyon" },
  { id: "premium", label: "Premium" },
];

export default function Products({ onAddToCart, onQuickView }) {
  const { products, categories } = useProducts();
  const [active, setActive] = useState("all");

  // "Premium" sekmesi indirim rozetine göre değil, panelde tanımlı gerçek
  // "Premium Çiçek" kategorisine göre filtreler — indirimli ürünleri
  // "Premium" diye göstermek yanıltıcı olurdu, kategori adına göre eşleşmek
  // hem doğru hem de panelden yönetilebilir (kategori adı değişirse burası
  // da otomatik uyar).
  const filtered = useMemo(() => {
    if (active === "all") return products;
    if (active === "premium") {
      const premiumCatIds = categories
        .filter((c) => c.name.toLocaleLowerCase("tr-TR").includes("premium"))
        .map((c) => c.id);
      return products.filter((p) => premiumCatIds.includes(p.cat));
    }
    return products.filter((p) => p.badges?.includes(active));
  }, [active, products, categories]);

  return (
    <section
      id="urunler"
      className="py-20 md:py-28 lg:py-32 bg-[#F8F8F8]"
      data-testid="products-section"
    >
      <div className="frida-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 lg:mb-14 gap-6">
          <div>
            <div className="text-xs tracking-[0.25em] uppercase text-[#A85C34] font-medium mb-3">
              · Vitrin ·
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#222222] tracking-tight leading-[1.1]" data-testid="products-title">
              Öne Çıkan <span className="italic text-[#A85C34]">Ürünler</span>
            </h2>
          </div>

          {/* Tabs */}
          <div className="flex items-center gap-6 sm:gap-8 overflow-x-auto no-scrollbar" data-testid="products-tabs">
            {TABS.map((t) => (
              <button
                key={t.id}
                onClick={() => setActive(t.id)}
                data-testid={`products-tab-${t.id}`}
                className={`relative pb-2.5 text-xs sm:text-[13px] tracking-[0.15em] uppercase font-medium whitespace-nowrap transition-colors ${
                  active === t.id ? "text-[#222222]" : "text-[#999999] hover:text-[#555555]"
                }`}
              >
                {t.label}
                {active === t.id && (
                  <motion.span
                    layoutId="products-tab-underline"
                    transition={{ type: "spring", stiffness: 400, damping: 32 }}
                    className="absolute left-0 right-0 -bottom-px h-[2px] bg-[#D4A15C]"
                  />
                )}
              </button>
            ))}
          </div>
        </div>

        <motion.div
          key={active}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8"
          data-testid="products-grid"
        >
          {filtered.map((p) => (
            <ProductCard
              key={p.id}
              product={p}
              onAddToCart={onAddToCart}
              onQuickView={onQuickView}
            />
          ))}
        </motion.div>

        <div className="text-center mt-14">
          <Link
            to="/urunler"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white border border-[#222222] text-[#222222] rounded-full font-medium hover:bg-[#222222] hover:text-white transition-all"
            data-testid="products-view-all"
          >
            Tüm Ürünleri Gör
          </Link>
        </div>
      </div>
    </section>
  );
}
